import {
  AutocompleteMultiSelect,
  type AutocompleteMultiSelectOption,
} from './AutocompleteMultiSelect';

export type SimpleMultiSelectOption = AutocompleteMultiSelectOption;

export interface SimpleMultiSelectProps {
  label: string;
  options: SimpleMultiSelectOption[];
  value: string[];
  onValueChange: (value: string[]) => void;
  placeholder?: string | undefined;
  emptyMessage?: string | undefined;
  disabled?: boolean | undefined;
  className?: string | undefined;
}

export function SimpleMultiSelect({
  label,
  options,
  value,
  onValueChange,
  placeholder,
  emptyMessage,
  disabled,
  className,
}: SimpleMultiSelectProps) {
  return (
    <AutocompleteMultiSelect
      label={label}
      options={options}
      value={value}
      onValueChange={onValueChange}
      placeholder={placeholder}
      emptyMessage={emptyMessage}
      disabled={disabled}
      className={className}
      controlClassName="px-1.5"
      inlineSelectedValues
    />
  );
}
